import store from '@/store/index.js'
export default {
	data () {
		return {
			imgUrl: '',

		}
	},
	computed: {
		nowRouteName(){
			//console.log('store.state.nowRouteName',store.state.nowRouteName)
			return store.state.nowRouteName
		},
		winH(){
			return store.state.winH
		},
		winW(){
			return store.state.winW
		},
		friendLink(){
			return store.state.friendLink
		}
	},
	
	methods:{
		clog(type,value){
			if(store.state.debug){
				type = type?type:''
				console.log(type,value)
			}
		},
		goUrl(data){
			if(data){
				console.log('data',data)
				//data:url('/index'),object({path:'/index',})
				this.$router.push(data)
			}
		},
		goUrlOut(url){
			if(url){ window.open(url) }
		},
		goBack(){
			this.$router.go(-1);//返回上一层
		},
		
	}
}



// WEBPACK FOOTER //
// ./src/mixins/index.js